import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography
} from '@mui/material';
import ApprovedFarmers from './ApprovedFarmers';
import { getApprovedFarmersCount, getAdminCount } from '../../services/admin/adminService';

/**
 * Composant pour la gestion des agriculteurs
 */
const Farmers = () => {
  // Nous n'avons plus besoin de gérer les onglets, nous affichons directement les agriculteurs approuvés
  const [loading, setLoading] = useState(true);
  const [counts, setCounts] = useState({
    approvedFarmersCount: 0,
    adminCount: 0
  });

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        setLoading(true);
        const approvedFarmersCount = await getApprovedFarmersCount();
        const adminCount = await getAdminCount();
        
        setCounts({
          approvedFarmersCount,
          adminCount
        });
      } catch (error) {
        console.error('Erreur lors de la récupération des compteurs:', error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchCounts();
  }, []);

  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 3, color: '#014527', fontWeight: 'bold' }}>
        Gestion des Agriculteurs
      </Typography>

      {/* Afficher directement les agriculteurs approuvés */}
      <ApprovedFarmers />
    </Box>
  );
};

export default Farmers;